import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../auth.service";
import { BreakpointObserver } from "@angular/cdk/layout";
import { LoggedIn } from "../../model/loggedIn";

@Component({
  selector: "dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  username: string = "";
  userPassFormVisible: boolean = false;
 screen: "mobile" | "tablet" | "desktop" = "desktop";

  isLoadingUserPassForm: boolean = false;

  constructor(
    private router: Router,
    private auth: AuthService,
    private breakpointObserver: BreakpointObserver
  ) {}

ngOnInit() {
  this.username = this.loggedInUser.label;

  this.breakpointObserver
    .observe([
      "(max-width: 850px)",                     // mobile
      "(min-width: 851px) and (max-width: 1300px)", // tablet
      "(min-width: 1301px)"                     // desktop
    ])
    .subscribe((state) => {
      if (state.breakpoints["(max-width: 850px)"]) {
        this.screen = "mobile";
      } else if (state.breakpoints["(min-width: 851px) and (max-width: 1300px)"]) {
        this.screen = "tablet";
      } else if (state.breakpoints["(min-width: 1301px)"]) {
        this.screen = "desktop";
      }
    });
}


  logout(): void {
    this.auth.logout();
    this.router.navigate(["/login"]);
  }

  showUserPassForm() {
    this.isLoadingUserPassForm = true;
    this.userPassFormVisible = false;

    setTimeout(() => {
      this.username = this.loggedInUser.username;

      if (this.username && this.username.trim() !== "") {
        this.userPassFormVisible = true;
      }

      this.isLoadingUserPassForm = false;
    }, 300);
  }

  cancelPasswordChange() {
    this.userPassFormVisible = false;
  }
  get loggedInUser(): LoggedIn {
    const user = this.auth.userdata;
 if (!user.username || user.username.trim() === "") {
      const stored = localStorage.getItem("currentLoggedIn");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          return new LoggedIn(
            parsed.id ?? 0,
            parsed.username ?? "",
            parsed.label ?? "",
            parsed.email ?? "",
            parsed.supervisor === true || parsed.supervisor === "true",
            parsed.lang ?? ""
          );
        } catch (e) {
          console.error("Erro ao parsear currentLoggedIn do localStorage:", e);
        }
      }
    }
    return user;
  }
}
